import * as React from 'react';
import styled from 'styled-components';
import { SelectField } from '../../designSystem/formField/SelectField';
import { P } from '../../designSystem/typography/Body';
import { clientAccessHelper } from '../../utils/clientAccessHelper';
import { ProtectedPageContext } from '../_contexts/ProtectedPageContext';
import { MemberPageWrapper } from '../_pageWrappers/MemberPageWrapper';
import { ButtonOverview } from './components/ButtonOverview';
import { ColorOverview } from './components/ColorOverview';
import { ContainerOverview } from './components/ContainerOverview';
import { tablet } from '../../designSystem/BreakPoints';
import { CardsOverview } from './components/CardsOverview';
import { DateTimeOverview } from './components/DateTimeOverview';
import { FieldChangePanelOverview } from './components/FieldChangePanelOverview';
import { FileLinkCommentOverview } from './components/FileLinkCommentOverview';
import { FormComponentsOverview } from './components/FormComponentsOverview';
import { FormFieldOverview } from './components/FormFieldOverview';
import { GraphicsOverview } from './components/GraphicsOverview';
import { HtmlEditorOverview } from './components/HtmlEditorOverview';
import { IconOverview } from './components/IconOverview';
import { InspectionPointOverview } from './components/InspectionPointOverview';
import { LayoutOverview } from './components/LayoutOverview';
import { ListRowOverview } from './components/ListRowOverview';
import { ModalOverview } from './components/ModalOverview';
import { SelectionOverview } from './components/SelectionOverview';
import { TabOverview } from './components/TabOverview';
import { TextInputOverview } from './components/TextInputOverview';
import { TooltipOverview } from './components/TooltipOverview';
import { TypographyOverview } from './components/TypographyOverview';
import { PageSectionOverview } from './components/PageSectionOverview';
import { ChipOverview } from './components/ChipOverview';
import { ListItemOverview } from './components/ListItemOverview';
import { AvatarOverview } from './components/AvatarOverview';

const Page = styled.div`
    padding: 20px;
    margin: 50px;

    @media (max-width: ${tablet}px) {
        margin:0;
    }
`;


const Pages = ['Avatar', 'Colors', 'Typography', 'Buttons', 'TextInput', 'Selection', 'FormField', 'DateTime', 'Cards and messages', 'Modal', 'Icons', 'Graphics', 'Tooltip', 'Layout', 'Containers', 'ListRow', 'Tab', 'InspectionPoints', 'FieldChangePanel', 'FormComponents', 'HtmlEditor', 'FileLinkComment', 'PageSection', 'Chip', 'ListItem'] as const;
type PageType = typeof Pages[number];
const defaultPageType: PageType = 'Chip';



export function DesignSystemPage (): JSX.Element
{
    return (
        <MemberPageWrapper>
            <DesignSystemPageContent />
        </MemberPageWrapper>
    );
}

function DesignSystemPageContent (): JSX.Element
{
    const activeUser = React.useContext(ProtectedPageContext).user;
    const hasAccess = clientAccessHelper.hasAllPermissions(activeUser, ['UserAdmin']);

    const [page, setPage] = React.useState<PageType>(() =>
    {
        // getting stored value
        const saved = localStorage.getItem("DesignSystemPage");
        return (saved || defaultPageType) as PageType;
    });

    React.useEffect(() =>
    {
        localStorage.setItem("DesignSystemPage", page);
    }, [page]);

    if (!hasAccess)
        return <P>Hov! Du har ikke rettigheder til at tilgå denne side.</P>;

    return (
        <>
            <Page>
                <div style={{ width: '200px', marginBottom: '10px' }}>
                    <SelectField
                        selectedValue={page}
                        options={Pages.map(p => ({ text: p, value: p })).sort((a, b) => a.text.localeCompare(b.text))}
                        onChange={newValue => setPage(newValue as PageType)}
                        label="Vælg afsnit"
                    />
                </div>

                <DesignSystemContainer>
                    {page === 'Avatar' &&
                        <AvatarOverview />
                    }
                    {page === 'Buttons' &&
                        <ButtonOverview />
                    }
                    {page === 'Cards and messages' &&
                        <CardsOverview />
                    }
                    {page === 'Colors' &&
                        <ColorOverview />
                    }
                    {page === 'DateTime' &&
                        <DateTimeOverview />
                    }
                    {page === 'FormField' &&
                        <FormFieldOverview />
                    }
                    {page === 'Typography' &&
                        <TypographyOverview />
                    }
                    {page === 'Icons' &&
                        <IconOverview />
                    }
                    {page === 'Modal' &&
                        <ModalOverview />
                    }
                    {page === 'Selection' &&
                        <SelectionOverview />
                    }
                    {page === 'TextInput' &&
                        <TextInputOverview />
                    }
                    {page === 'Graphics' &&
                        <GraphicsOverview />
                    }
                    {page === 'Tooltip' &&
                        <TooltipOverview />
                    }
                    {page === 'Layout' &&
                        <LayoutOverview />
                    }
                    {page === 'Containers' &&
                        <ContainerOverview />
                    }
                    {page === 'ListRow' &&
                        <ListRowOverview />
                    }
                    {page === 'Tab' &&
                        <TabOverview />
                    }
                    {page === 'InspectionPoints' &&
                        <InspectionPointOverview />
                    }
                    {page === 'FieldChangePanel' &&
                        <FieldChangePanelOverview />
                    }
                    {page === 'FormComponents' &&
                        <FormComponentsOverview />
                    }
                    {page === 'HtmlEditor' &&
                        <HtmlEditorOverview />
                    }
                    {page === 'FileLinkComment' &&
                        <FileLinkCommentOverview />
                    }
                    {page === 'PageSection' &&
                        <PageSectionOverview />
                    }
                    {page === 'Chip' &&
                        <ChipOverview />
                    }
                    {page === 'ListItem' &&
                        <ListItemOverview />
                    }
                </DesignSystemContainer>
            </Page>
        </>
    );
}

const DesignSystemContainer = styled.div`
    /* border: 1px solid gray;
    border-radius: 4px;
    padding: 20px; */
`;